import { Grid } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import {
  APP_VIEW,
  DEPENDENT_FIELDS,
  RECORD_DETAILS_STRUCTURE,
  RECORD_DETAILS_STRUCTURE_CCM,
  DETAILS_FIELD_FORMATTING,
  DEPENDENT_FIELDS_CCM,
  ROUTE_DM,
  BASE_CODE_ERROR,
  REASON_CODES_CCM,
  REASON_CODES_BP,
} from "../constants/constant";
import { calculateDependent, calculateDependentCCM } from "../utils/utils";
import Field from "./field";
import { useTranslation } from "./translation-context";

const DetailPanelFunction = (props) => {
  const { translate: t } = useTranslation();
  const [editedvalues, setEditedvalues] = useState({});
  const { editableFields } = props;

  const generateEditableValuesSet = () => {
    if (editableFields) {
      setEditedvalues(
        Object.keys(editableFields).reduce((obj, fields) => {
          if (
            fields === "originalDueDate" &&
            props.row["country"] === "DE" &&
            (props.row["itemText"].includes("KFZ") ||
              props.row["itemText"].includes("Brief") ||
              props.row["itemText"].includes("zurück")) &&
            props.row[fields]
          ) {
            obj["originalDueDate"] = props.row[fields];
            return obj;
          }
          if (
            (fields === "originalDocDate" || fields === "originalDueDate") &&
            props.row[fields]
          ) {
            return obj;
          }
          if (fields === "itemTextForExtendedAmount") {
            obj[fields] = props.row[fields];
            return obj;
          }
          obj[fields] = props.row[fields];
          return obj;
        }, {}),
      );
    }
  };

  useEffect(() => {
    if (props.enableEditing) {
      generateEditableValuesSet();
    }
  }, [props.enableEditing]);

  const hasDate = (itemTextForExtendedAmount) => {
    const regex = /\b\d{2}\.\d{2}\.\d{4}$/;
    const match = itemTextForExtendedAmount.match(regex);
    if (match) {
      itemTextForExtendedAmount = itemTextForExtendedAmount.replace(
        match[0],
        "",
      );
    }
    return itemTextForExtendedAmount;
  };

  const fieldChanged = (field, value) => {
    
    let latest = { ...editedvalues, [field]: value };
    if (DEPENDENT_FIELDS[field] && props.view === APP_VIEW.BP) {
      latest = calculateDependent(latest, field, props.row);
    } else if (DEPENDENT_FIELDS_CCM[field] && props.view === APP_VIEW.CCM) {
      latest = calculateDependentCCM(latest, field, props.row);
    } else if (
      field === "originalDueDate" &&
      props.row["extensionType"] === "IE" &&
      props.view === APP_VIEW.BP
    ) {
      latest["itemTextForExtendedAmount"] =
        hasDate(latest["itemTextForExtendedAmount"]) +
        dayjs(value).format("DD.MM.YYYY").toString();
    } else if (
      field === "originalDueDate" &&
      props.row["extensionType"] === "TI" &&
      props.row["country"] === "FR" &&
      props.view === APP_VIEW.CCM
    ) {
      const itemTextWithDate =
        props.row.itemTextForExtendedAmount.split("  ")[0] + " ";
      const serialNoWithItemText =
        props.row.itemTextForExtendedAmount.split("  ")[1];
      latest["itemTextForExtendedAmount"] =
        hasDate(itemTextWithDate) +
        dayjs(value).format("DD.MM.YYYY").toString() +
        " " +
        serialNoWithItemText;
    }
    // For AP extension type, update itemTextForExtendedAmount when dependent fields change
    if (
      props.row["extensionType"] === "AP" &&
      (field === "newCalculatedDate" || field === "daysOfExtension")
    ) {
      const dateToUse =
        field === "newCalculatedDate" ? value : latest["newCalculatedDate"];
      const parts = props.row.itemTextForExtendedAmount.split(" ");
      if (parts.length >= 2 && dateToUse) {
        parts[1] = dayjs(dateToUse).format("DD.MM.YYYY");
        latest["itemTextForExtendedAmount"] = parts.join(" ");
      }
    }
    setEditedvalues(latest);
    props.onChange(latest);
  };

  const renderFieldOrText = (item) => {
    if (
      item === "baseCode" &&
      props.row.reasonForCheck === BASE_CODE_ERROR &&
      props.pageView === APP_VIEW.ERRORS
    ) {
      return (
        <Field
          type="link"
          link={`${ROUTE_DM}#`}
          setItem={true}
          name={props.row[item]}
        />
      );
    }
    if (
      item === "valuta" &&
      (props.row.extensionType !== "EF" || props.row.country !== "DE")
    ) {
      return "";
    } else {
      if (
        props.enableEditing &&
        editedvalues &&
        editedvalues.hasOwnProperty(item)
      ) {
        return (
          <Field
            view={props.view}
            optionsCCM={REASON_CODES_CCM}
            optionsBP={REASON_CODES_BP}
            recordData={props.row}
            onChange={(value) => fieldChanged(item, value)}
            attr={editableFields[item]}
            type={editableFields[item].type}
            value={editedvalues[item]}
            endPlaceHolder={
              DETAILS_FIELD_FORMATTING.hasOwnProperty(item) &&
              DETAILS_FIELD_FORMATTING[item].type === "custom"
                ? DETAILS_FIELD_FORMATTING[item].value
                : props.row.currencyKey
            }
          />
        );
      } else if (DETAILS_FIELD_FORMATTING.hasOwnProperty(item)) {
        if (DETAILS_FIELD_FORMATTING[item].type === "date") {
          return props?.row[item] !== null
            ? dayjs(props?.row[item]).format("DD-MM-YYYY")
            : null;
        } else if (DETAILS_FIELD_FORMATTING[item].type === "amount") {
          return (
            (props?.row[item] !== null
              ? parseFloat(
                  parseFloat(props?.row[item]).toFixed(2),
                ).toLocaleString("de-DE")
              : 0) +
            " " +
            props.row.currencyKey
          );
        } else if (DETAILS_FIELD_FORMATTING[item].type === "custom") {
          return (
            (props?.row[item] !== null ? props?.row[item] : "") +
            " " +
            DETAILS_FIELD_FORMATTING[item].value
          );
        }
      }

      return props?.row[item] !== null ? props?.row[item] : "";
    }
  };

  const isManualRequest = props.row?.longTextForDocLineItem?.includes("MAN");

  const resolveField = (item) =>
    props.view === APP_VIEW.CCM && item === "userName" && isManualRequest
      ? "userID"
      : item;

  const generateDetailsSections = (fields) => {
    return (
      <Grid
        key={JSON.stringify(fields)}
        xs={4}
        className="sub"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {fields
          .map(resolveField)
          .filter(
            (item) =>
              props.view !== APP_VIEW.BP ||
              item !== "userID" ||
              isManualRequest,
          )
          .map((item) =>
          item === "amountToExtend" &&
          props.view === APP_VIEW.CCM &&
          props.row.extensionType !== "EF" ? (
            ""
          ) : (
            <div key={item} style={{ display: "flex", padding: "5px 0" }}>
              <span style={{ width: "50%" }}>
                <b>
                  {item === "valuta"
                    ? props.row.extensionType === "EF" &&
                      props.row.country === "DE"
                      ? t(item)
                      : ""
                    : t(item)}
                </b>
              </span>
              <span style={{ width: "50%" }}>{renderFieldOrText(item)}</span>
            </div>
          ),
          )}
      </Grid>
    );
  };

  const generateDetails = () => {
    return props.view === APP_VIEW.CCM
      ? RECORD_DETAILS_STRUCTURE_CCM.map((fields) =>
          generateDetailsSections(fields),
        )
      : RECORD_DETAILS_STRUCTURE.map((fields) =>
          generateDetailsSections(fields),
        );
  };

  return (
    <div className="details-panel">
      <Grid container spacing={1}>
        <Grid
          xs={12}
          className="main"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: "50px",
            padding: "10px",
            background: "#FFF",
          }}
        >
          {generateDetails()}
        </Grid>
      </Grid>
    </div>
  );
};

export default DetailPanelFunction;
